import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generalAppInfo } from '../utils/constants';
import { getBaseUrl, getBaseUrlEnv } from '../utils/axios.service';

const dodgeBaseQuery = fetchBaseQuery({
  baseUrl: getBaseUrl()['web'],

  prepareHeaders: headers => {
    const token = getBaseUrlEnv() === 'PRODUCTION' ? generalAppInfo.SIJU_PK : generalAppInfo.SIJU_STAGING_PK;
    headers.set("Content-Type", 'application/json');
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers
  }
});


export const dodgeQuery = createApi({
  baseQuery: dodgeBaseQuery,
  reducerPath: 'dodgeQuery',
  tagTypes: ["TRIPS"],
  endpoints: builder => ({
    getTripInfo: builder.query({
      query: filter => `/booking-service/booking/booking-trip/checkout_page/?reference=${filter}`,
      providesTags: ['TRIPS']
    }),
    getOrdersetTripInfo: builder.query({
      query: filter => `/booking-service/booking/booking-trip/get_trip_by_orderset_reference/?orderset=${filter}`,
      providesTags: ['TRIPS']
    }),
    getVehicles: builder.query({
      query: body => ({ 
        url: `/booking-service/booking/booking-organisation-profile/get_booking_category_sizes/?trip_type=${body.trip_type}`,
        headers: { organisation: body.organisation } }),
    }),
    // getTripTypes: builder.mutation({
    //   query: organisation => ({ url: `/booking-service/booking/booking-organisation-profile/get_organisation_trip_type/`, method: "GET", headers: { organisation } }),
    // }),
    // getExtras: builder.mutation({
    //   query: organisation => ({ url: `/booking-service/booking/booking-organisation-profile/get_extras/`, method: "GET" ,headers: { organisation } }),
    // }),
    getQuoteEstimate: builder.mutation({
      query: body => ({ 
        url: `/booking-service/booking/booking-trip/check_quote/`,
         body: body.payload, 
        method: "POST", 
         headers: { organisation: body.organisation } }),
    }),
    updateTripQuote: builder.mutation({
      query: body => ({
        url: `/booking-service/booking/booking-check-quote/${body.id}/`,
        body: body.payload,
        method: "PATCH",
        headers: { organisation: body.organisation }
      }),
    }),
    bookTrip: builder.mutation({
      query: body => ({
        url: `/booking-service/booking/booking-trip/create_open_trip/`,
        body: body.payload,
        method: "POST",
        headers: { organisation: body.organisation }
      }),
    })
  })
})

export const {
  useGetTripInfoQuery,
  useLazyGetTripInfoQuery,
  useGetOrdersetTripInfoQuery,
  useGetVehiclesQuery,
  // useGetTripTypesMutation,
  // useGetExtrasMutation,
  useGetQuoteEstimateMutation,
  useUpdateTripQuoteMutation,
  useBookTripMutation,
} = dodgeQuery;